<template>
    <div
        v-if="loaded"
        class="af-login-form"
    >
        <div
            v-if="showCreatePassword"
            class="afu-w-full afu-p-3 sm:afu-p-5 afu-bg-neutral--light afu-shadow-secondary afu-rounded-secondary afu-m-auto sm:afu-max-w-md afu-w-100 afu-box-border"
        >
            <div class="afu-text-center afu-mb-11">
                <h2 class="af-text--9xl afu-text-black afu-font-bold md:afu-font-semibold">
                    {{ $t('login.title') }}
                </h2>

                <p class="afu-mb-0 afu-text-black">
                    {{ $t('login.info') }}
                </p>
            </div>

            <ForgotPassword
                :prefill-email="email"
                mode="create_password"
            />
        </div>
        <div
            v-else
            class="afu-w-full afu-p-3 sm:afu-p-5 afu-bg-neutral--light afu-shadow-secondary afu-rounded-secondary afu-m-auto sm:afu-max-w-md afu-w-100 afu-box-border"
        >
            <div class="afu-text-center afu-mb-11">
                <h2 class="af-text--9xl afu-text-black afu-font-bold md:afu-font-semibold">
                    {{ $t('login.title') }}
                </h2>

                <p class="afu-mb-0 afu-text-black">
                    {{ $t('login.info') }}
                </p>
            </div>

            <div class="af-login-form">
                <C1Alert
                    v-if="!!response.message"
                    :variant="response.variant"
                >
                    <span v-html="response.message" />
                </C1Alert>
                <div 
                    v-if="true"
                    class="afu-login-with-accounts" 
                >
                    <AuthGoogle />
                    <AuthLinkedIn />
                    <div class="afu-text-center afu-w-full afu-my-10">
                        <span class="strike-text afu-font-light">Or login with your email</span>
                    </div>
                </div>

                <ValidationObserver
                    ref="loginForm"
                    tag="form"
                    @submit.stop.prevent="onSubmit"
                >
                    <ValidationProvider
                        name="email address"
                        rules="required|email"
                        v-slot="{ errors }"
                    >
                        <C1FormGroup>
                            <C1FormInput
                                id="email"
                                :label="$t('label.email_address')"
                                label-for="email"
                                v-model="email"
                                :is-invalid="!!errors[0]"
                                :invalid-feedback="errors[0]"
                                name="email"
                                type="email"
                                :placeholder="$t('label.email_address')"
                            />
                        </C1FormGroup>
                    </ValidationProvider>

                    <ValidationProvider
                        name="password"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <C1FormGroup>
                            <a
                                class="af-text--base afu-text-neutral-dark hover:afu-text-neutral-dark afu-no-underline hover:afu-no-underline afu-float-right"
                                :href="getLocalePath('/user-forgot-password')"
                            >
                                {{ $t('label.forgot_password') }}?
                            </a>
                            <C1FormInput
                                id="password"
                                :label="$t('label.password')"
                                label-for="password"
                                v-model="password"
                                :is-invalid="!!errors[0]"
                                :invalid-feedback="errors[0]"
                                type="password"
                                :placeholder="$t('label.enter_your_value', {value: $t('label.placeholder_password')})"
                            />
                        </C1FormGroup>
                    </ValidationProvider>

                    <C1Button
                        type="submit"
                        variant="primary"
                        class="afu-mt-5"
                        size="lg"
                        block
                        :is-busy="spinner.register"
                    >
                        {{ $t('label.login') }}
                    </C1Button>
                </ValidationObserver>
            </div>
        </div>
        <div class="af-register-link afu-text-center afu-mt-5 md:afu-mt-0">
            <span class="af-label afu-font-light">
                {{ $t('label.dont_have_account') }}
            </span>
            <a
                :href="getLocalePath('/user-register')"
                class="afu-text-primary hover:afu-text-primary afu-underline hover:afu-no-underline afu-font-light"
            >
                {{ $t('label.register') }}
            </a>
        </div>
    </div>
    <!-- New page load skeleton -->
    <div
        v-else
        class="af-login-form"
    >
        <div class="afu-w-full afu-p-3 sm:afu-p-5 afu-bg-neutral--light afu-shadow-secondary afu-rounded-secondary afu-m-auto sm:afu-max-w-md afu-w-100 afu-box-border">
            <div class="af-attribute-skeleton af-attribute-filter afu-mt-4 afu-mb-11 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                <div class="afu-bg-gray-500 afu-w-full afu-animate-pulse afu-h-8 afu-mb-4 afu-rounded-2xl" />
            </div>
            <div class="af-attribute-skeleton af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                <div
                    v-for="n in 2"
                    :key="n"
                >
                    <div class="afu-bg-gray-400 afu-w-40 afu-animate-pulse afu-h-4 afu-mb-4 afu-rounded-2xl" />
                    <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-8 afu-mb-4 afu-rounded-2xl" />
                </div>
                <div class="afu-bg-gray-500 afu-w-full afu-animate-pulse afu-h-11 afu-mb-4 afu-rounded-2xl" />
            </div>
            <div class="af-attribute-skeleton af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-6 afu-mb-4 afu-rounded-2xl" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    import AuthMixin from '@/components/Auth/AuthMixin';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import C1Button from '@/components/C1Components/C1Button';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';
    import ForgotPassword from '@/apps/forgot-password/001/components/ForgotPassword';
    import AuthGoogle from '@/components/Auth/AuthGoogle';
    import AuthLinkedIn from '@/components/Auth/AuthLinkedIn';
    

    export default {
        name: 'LoginForm',

        components: {
            C1FormGroup,
            ValidationObserver,
            ValidationProvider,
            C1Alert,
            C1Button,
            C1FormInput,
            ForgotPassword,
            AuthGoogle,
            AuthLinkedIn,
        },

        mixins: [AuthMixin],

        data() {
            return {
                response: {
                    variant: '',
                    message: '',
                },
                spinner: {
                    register: false,
                },
                email: '',
                password: '',
                showCreatePassword: false,
            };
        },

        computed: {
            ...mapState({
                $_apiMessage: state => state.apiMessage,
            }),
        },

        async created() {
            await this.$_redirectIfAuthenticated();
            await this.$recaptchaLoaded();
        },

        methods: {
            ...mapActions('auth', {
                $_forgotPassword: 'forgotPassword',
            }),

            async onSubmit() {
                const validate = await this.$refs.loginForm.validate();
                if (!validate) {
                    return;
                }

                const token = await this.$recaptcha('login');
                if (!token) {
                    return;
                }

                const data = {
                    email: this.email,
                    password: this.password,
                    token: token,
                };

                this.spinner.register = true;

                this.$_login(data)
                    .then(() => {
                        let redirect = '/user-dashboard';

                        const urlParams = new URLSearchParams(
                            window.location.search,
                        );
                        const redirectParam = urlParams.get('redirect');
                        if (redirectParam) {
                            redirect = redirectParam;
                        }

                        window.location.href = redirect;
                    })
                    .catch(error => {
                        const errorCode = error.response.data.error;
                        if (errorCode === 'NoPasswordException') {
                            this.showCreatePassword = true;
                            this.$_forgotPassword({
                                email: this.email,
                                code: true,
                            }).catch(error => {
                                const errorCode =
                                    error?.response?.data?.error ||
                                    'ServerErrorException';
                                this.response.variant = 'danger';
                                this.response.message = this.$t(
                                    `api_message.${errorCode}`,
                                );
                            });
                        }
                        this.response.message = this.$t(`api_message.${errorCode}`);
                        if (errorCode == 'MaxAttemptsException') {
                            this.response.message += this.$t('account.try_again');
                        }
                        this.response.variant = 'danger';

                        this.spinner.register = false;
                    });
            },
        },
    };
</script>
